var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.528 3.529c.26-.26.683-.26.943 0L8 7.057l3.528-3.528a.667.667 0 1 1 .943.942L8.942 8l3.53 3.528a.667.667 0 0 1-.944.943L8 8.943 4.47 12.47a.667.667 0 1 1-.943-.943L7.057 8 3.528 4.47a.667.667 0 0 1 0-.942Z"
  })));
};

export default SvgClose;